import { useMemo } from 'react'

import { Table } from 'core-components/library/list'
import { Logic, Operator } from 'core-components/types'
import { useMeasureController } from 'core/analytics/useMeasureController'

import { columns } from './config'
import { getJbpGlobalPartnerPartnersContactsCrud } from './helpers/getJbpGlobalPartnerPartnersContactsCrud'
import { IGpContactsListProps } from './models/gpContactsListProps'

export const GpContactsList = ({
  fYear,
  partnerId,
  flexWidth,
  metrics,
  onSelectGpContact,
}: IGpContactsListProps) => {
  const crud = getJbpGlobalPartnerPartnersContactsCrud()

  const measure = useMeasureController(metrics)

  const source = useMemo(() => {
    if (partnerId && fYear) {
      crud.setFilter({
        logic: Logic.AND,
        filters: [
          {
            field: 'GlobalPartnerId',
            operator: Operator.EQUAL,
            value: partnerId,
          },
        ],
      })
    }

    return crud
  }, [crud, partnerId, fYear])

  return (
    <Table
      header
      hasExport
      pagination
      columns={columns}
      source={source}
      flexWidth={flexWidth}
      measure={measure}
      rowActions={[
        {
          id: 'Select',
          action: onSelectGpContact,
          title: 'Select',
          icon: 'kbase kbase-add',
        },
      ]}
      rowActionsVisible="visible"
    />
  )
}
